/* eslint-disable max-len */

import React from "react"

import BaseSvgIcon from "./Base"

const PriceTag = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 12 12">
    <path
      d="M11.6836 0C11.8582 0 11.9999 0.141735 12 0.316406V5.35352C12 5.43772 11.9661 5.51827 11.9072 5.57715L5.60254 11.9072C5.54308 11.9666 5.46198 12 5.37793 12C5.29382 12 5.21311 11.9661 5.1543 11.9072L0.0927734 6.84277C0.0332986 6.78326 0 6.7014 0 6.61719C0.000117939 6.53321 0.0338387 6.4533 0.09375 6.39453L6.4209 0.0917969C6.47973 0.0335952 6.56007 0 6.64355 0H11.6836ZM0.764648 6.61914L5.37695 11.2354L6.50977 10.0986L1.90137 5.48633L0.764648 6.61914ZM2.34961 5.04004L6.95703 9.65039L11.3672 5.22363V0.633789H6.77344L2.34961 5.04004ZM9.1748 1.87012C9.69789 1.87032 10.124 2.29682 10.124 2.82031C10.1236 3.34341 9.69761 3.76933 9.1748 3.76953C8.65184 3.76953 8.22605 3.34353 8.22559 2.82031C8.22559 2.2967 8.65155 1.87012 9.1748 1.87012ZM9.1748 2.50391C9.00072 2.50394 8.8584 2.64622 8.8584 2.82031C8.85865 2.9942 9.00087 3.13668 9.1748 3.13672C9.34867 3.1366 9.49096 2.99415 9.49121 2.82031C9.49121 2.64627 9.34882 2.50402 9.1748 2.50391Z"
      fill="black"
    />
  </BaseSvgIcon>
)

export default PriceTag
